import Blue from '~/core'

new Blue({
  name: 'Product Info',
  selector: '.product-info',
  setup(container) {
    const headers = [...container.querySelectorAll('.product-info__header .product-info__cell')]
    const triggers = [...container.querySelectorAll('.product-info__trigger')]
    const items = [...container.querySelectorAll('[class*=__item]')]
    container.setAttribute('style', '--columns: ' + headers.length)
    let relations = []
    items.forEach((container) => {
      let trigger = container.querySelector('[class*=__trigger]')
      let content = container.querySelector('[class*=__content]')
      let config = {
        container,
        trigger,
        content,
        props: ['height', 'opacity', 'visibility'],
        relations,
        // scrollTest: () => true
      }
      relations.push(new this.$toggle(config))
    })
    triggers.forEach((trigger) => {
      const item = trigger.closest('.product-info__item')
      const content = item.querySelector('.product-info__content')
      const cells = [...content.querySelectorAll('.product-info__cell')]
      this.$addEvents(trigger, 'click', (e) => {
        e.preventDefault()
        cells.forEach((cell) => {
          cell.animate([{ opacity: '0' }, { opacity: '1' }], {
            duration: 350,
            easing: 'ease',
          })
        })
      })
    })
  },
})
